import React, { createContext, useContext, useMemo } from 'react';
import { accessesKeys, defaultAccesses } from '../../constants/accesses';

const Context = createContext();

export const useAccesses = () => useContext(Context);

export const useCanChangeLifeCycle = () => {
  const { [accessesKeys.canChangeLifeCycle]: canChange } = useAccesses();

  return canChange;
};

export const AccessesProvider = ({ children, accesses }) => {
  const value = useMemo(() => {
    if (
      typeof accesses === 'object' &&
      accesses !== null &&
      !Array.isArray(accesses)
    ) {
      return Object.entries(defaultAccesses).reduce(
        (acc, [key, defaultValue]) => {
          acc[key] = Object.hasOwn(accesses, key)
            ? accesses[key]
            : defaultValue;

          return acc;
        },
        {}
      );
    }

    return defaultAccesses;
  }, [accesses]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
